import { Loader2 } from 'lucide-react';

export function Spinner({ label = 'Memuat…' }: { label?: string }) {
  return (
    <div className="flex h-full w-full items-center justify-center gap-2 text-slate-400">
      <Loader2 className="animate-spin" size={18} aria-hidden />
      <span className="text-sm">{label}</span>
    </div>
  );
}
